<div class="confirmation__modal">
  <div class="modal-header">
    <div class="modal-title">
      <span>{{title}}</span>
    </div>
  </div>

  <div class="modal-body text-center">
    <div class="row">
      <div class="col-md-12">
        <div class="small__text break-text">{{message}}</div>
      </div>
    </div>

    <div class="mt-3 d-flex">
      <button type="button" class="col-md-6 button color--blue medium__button popup__button" (click)="confirm()">
        Yes
      </button>
      <button type="button" class="col-md-6 button medium__button popup__button" (click)="decline()">
        No
      </button>
    </div>
  </div>
</div>
